import React from 'react';

function Pagination({
  totalItems,
  rowsPerPage,
  startIndex,
  onRowsPerPageChange,
  onFirstItems,
  onPreviousItems,
  onNextItems,
  onLastItems,
}) {
  const endIndex = startIndex + rowsPerPage;

  return (
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mb-3 small">
      {/* Contêiner central para alinhamento */}
      <div className="d-flex flex-column flex-md-row align-items-center mb-2">
        {/* Seletor de registros por página */}
        <div className="d-flex align-items-center me-3 mb-md-0">
          <label
            htmlFor="rowsPerPageSelect"
            className="form-label me-2 mb-1"
            style={{ whiteSpace: 'nowrap' }}
          >
            Exibir:
          </label>
          <select
            id="rowsPerPageSelect"
            className="form-select form-select-sm mb-1"
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
          >
            <option value={5}>05</option>
            <option value={10}>10</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={totalItems}>Todos</option>
          </select>
        </div>

        {/* Botões de navegação */}
        <div className="d-flex align-items-center flex-wrap justify-content-center">
          <button
            className="btn btn-sm btn-outline-primary me-1 mb-1"
            onClick={onFirstItems}
            disabled={startIndex === 0}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a primeira página"
          >
            <i className="bi bi-chevron-double-left"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-primary me-1 mb-1"
            onClick={onPreviousItems}
            disabled={startIndex === 0}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a página anterior"
          >
            <i className="bi bi-chevron-left"></i>
          </button>
          <span className="mx-2 mb-1 text-center">
            {startIndex + 1} - {Math.min(endIndex, totalItems)} de {totalItems}
          </span>
          <button
            className="btn btn-sm btn-outline-primary ms-1 mb-1"
            onClick={onNextItems}
            disabled={endIndex >= totalItems}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a próxima página"
          >
            <i className="bi bi-chevron-right"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-primary ms-1 mb-1"
            onClick={onLastItems}
            disabled={endIndex >= totalItems}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a última página"
          >
            <i className="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Pagination;
